import ContactIdMappingListResourceModel from '../../generated/types/model/resource/ContactIdMappingListResourceModel';

export default class ContactIdMappingListResourceViewModel extends ContactIdMappingListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
